export default __webpack_public_path__ + "static/media/maps-and-flags.273ddc81.svg";